import React from 'react';
import { Constants } from 'utils';
import { WhatsAppButton } from 'components';

interface Props {
  verified?: number;
  onUpdate?: any;
}

class BannerUpdateDocs extends React.Component<Props> {
  render() {
    const { verified } = this.props;
    const isRejected = verified === Constants.VERIFIED.REJECTED;

    // Solo los colores dinámicos quedan inline; el layout lo maneja el SCSS
    const bannerDynamicStyle: React.CSSProperties = {
      backgroundColor: isRejected ? '#fdecea' : '#fff8e1',
      border: '1px solid ' + (isRejected ? '#e53935' : '#f9a825'),
    };

    const textDynamicStyle: React.CSSProperties = {
      color: isRejected ? '#b71c1c' : '#5f4200',
    };

    const btnStyle: React.CSSProperties = {
      padding: '7px 16px',
      fontSize: '13px',
      fontWeight: 600,
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      backgroundColor: isRejected ? '#e53935' : '#f9a825',
      color: '#000000ff',
      whiteSpace: 'nowrap',
    };

    return (
      <div id='banner-update-docs' style={bannerDynamicStyle}>
        <p className='banner-update-texto' style={textDynamicStyle}>
          <span style={{ fontWeight: 600, marginRight: '6px' }}>
            {isRejected ? 'Solicitud rechazada.' : 'Documentos en revisión.'}
          </span>
          {isRejected
            ? 'Tu solicitud fue rechazada. Puedes enviar nuevos documentos para una nueva revisión.'
            : 'Tus documentos están siendo revisados. Puedes actualizarlos antes de que finalice la revisión.'}
        </p>
        <div className='banner-update-botones'>
          <button style={btnStyle} onClick={() => this.props.onUpdate()}>
            Actualizar documentos
          </button>
          {!isRejected && (
            <WhatsAppButton
              phoneNumber='584225342555'
              message='Hola, quiero agendar una cita para la verificación de mi cuenta en Legalmente.'
              buttonText='Agendar cita'
              style={btnStyle}
            />
          )}
        </div>
      </div>
    );
  }
}

export default BannerUpdateDocs;
